module.exports = __webpack_public_path__ + "static/resized_logo-7456a42532762459027ca49f42be1747.svg";